import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, NavLink, Link } from 'react-router-dom';
import { Form, Button, Alert } from "react-bootstrap";
import { ToastContainer, toast, Slide } from 'react-toastify';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useReactToPrint } from 'react-to-print';
import logoTransactions from '../../assets/SWU-PHINMA-logo.webp';
import axios from "axios";
import "../styles/Printable.css";
import "../styles/TctDelete.css";
import '../../App.css';
import 'react-toastify/dist/ReactToastify.css';
import { 
    FaTable,
    FaCheckCircle, 
    FaRegTimesCircle,
    FaClipboardCheck,
    FaSpinner,
    FaFileAlt,
    FaTruck,
    FaBoxOpen,
    FaPrint,
    FaBox,
    FaHands,
    FaRegCalendarTimes
} from 'react-icons/fa';
import { BsSendCheck } from "react-icons/bs";

export default function Transactions() {
    const notify = (type, message) => {
        const properties = {
          position: "top-center",
          transition: Slide,
          autoClose: 1900,
          draggable: true,
          closeOnClick: true,
          pauseOnHover: false,
        }

        if (toast[type]) {
            toast[type](message, properties); // e.g., toast.success("Success message")
        } else {
            toast(message, properties); // Default toast if type is unknown
        }

    }     
    
    const [dataCounts, setDataCounts] = useState({
        fullyPaid: 0,
        pendingBalance: 0,
        total: 0,
        archived: 0,
    });
    
    // let verticalbarItem = [];
    const [selectedVerticalTab, setVerticalTab] = useState("All");
    // const [dropdownFilter, setDropdownFilter] = useState(false);

    const totalVerticalbar = [
        {name: 'All', icon:<FaTable/>},
        {name: 'Paid', icon:<FaTable/>},
        {name: 'Not Paid', icon:<FaTable/>},
        {name: 'Pickup', icon:<FaHands/>},
        {name: 'Delivery', icon:<FaBox/>},
        {name: 'Request Placed', icon:<BsSendCheck/>},
        {name: 'In Review', icon:<FaSpinner/>},
        {name: 'Processing', icon:<FaSpinner/>},
        // {name: 'Accepted', icon:<FaClipboardCheck/>},
        {name: 'Rejected', icon:<FaClipboardCheck/>},
        {name: 'Completed', icon:<FaCheckCircle/>},
        {name: 'For Releasing', icon:<FaCheckCircle/>},
        {name: 'Claimed', icon:<FaBoxOpen/>},
        {name: 'Delivered', icon:<FaBoxOpen/>},
        {name: 'Overdue', icon:<FaRegCalendarTimes/>},
    ];

    // verticalbarItem = totalVerticalbar;    
    
    const [updateTrigger, setUpdateTrigger] = useState(false);

    const refreshTopData = () => {
        setUpdateTrigger(!updateTrigger);
    };

    // datacounts
    // TODO refer to api folder in htdocs
/*     useEffect(() => {
        const fetchDataCounts = async () => {
            try {
                const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/your-endpoint.php'); 
                setDataCounts(response.data);
            } catch (error) {
                console.error("Error fetching data counts:", error);
            }
        };
        
        fetchDataCounts();
    }, [updateTrigger]); */
    
    const getStatusPayment = (statusPayment) => {
        switch (statusPayment) {
          case "Paid":
            return "payment-status paid";
          case "Not Paid":
            return "payment-status not-paid";
          default:
            return "";
        }
    };

    const convertStatusTransit = (statusTransitRequest) => {
        switch (statusTransitRequest) {
            case "Request Placed":
                return "Request Placed"; 
            case "In Review":
                return "In Review";
            case "Payment Sent":
                return "In Review"; // trail stays on in review since payment receipt is needed to accept     
            case "Accepted":
                return "Accepted";
            case "Rejected":
                return "Rejected";       
            case "Processing":
                return "Processing";   
            case "Completed":
                return "Completed"; 
            case "For Releasing":
                return "For Releasing";                   
            case "Ready to Pick Up":
                return "Out for Delivery/Ready to Pick Up";
            case "Out for Delivery":
                return "Out for Delivery/Ready to Pick Up";
            // case "In Transit":
            //     return "In Transit"; // maps to In Transit
            case "Received":
                return "Received/Claimed";
            case "Claimed":
                return "Received/Claimed";
            case "Overdue":
                return "Overdue";
            default:
                //console.error("INVALID transit status");
                //console.warn("redirected to Request Placed");
                return "Request Placed"; // Default stage if no matches
        }
    };

    // TODO refer to latest statusTransit and css file
    function buildStatusClass(strStatus) {        
        switch (strStatus.toUpperCase()) {
          case "PROCESSING":
            return "in-review";    
            
          case "IN TRANSIT":
            return "in-progress";
        }
    }
    
    const formatDate = (timestamp) => {
        const date = new Date(timestamp); // Convert timestamp to Date object
        return date.toLocaleDateString('en-US', {
            month: 'short', // "Oct"
            day: 'numeric', // "6"
            year: 'numeric' // "2024"
        });
    };

    const [searchValue, setSearchValue] = useState('');

    const [transactions_data, setTransactions] = useState([]);
    const [filteredTransactions, setFilteredTransactions] = useState([]);

    const navigate = useNavigate();
    const [isPrinting, setIsPrinting] = useState(false);

    const [dateFilters, setDateFilters] = useState({
      released: { enabled: false, start: '', end: '' },
      created: { enabled: false, start: '', end: '' },
      updated: { enabled: false, start: '', end: '' },
    });
    
    const handleCheckboxChange = (type) => {
      setDateFilters((prev) => ({
        ...prev,
        [type]: { ...prev[type], enabled: !prev[type].enabled },
      }));
    };
    
    const handleDateChange = (type, field, value) => {
      setDateFilters((prev) => ({
        ...prev,
        [type]: { ...prev[type], [field]: value },
      }));
    };
    
    const isWithinRange = (dateString, startDate, endDate) => {
      if (!dateString) return false;
      const dateOnly = new Date(dateString).toISOString().split('T')[0];
      return dateOnly >= startDate && dateOnly <= endDate;
    };
    

    const [userCourses, setUserCourses] = useState([]);
    const [userId, setUserId] = useState('');

    const userIdRef = useRef('');
    const userFullnameRef = useRef('');
    const tableRef = useRef(null);
    const LogoRef = useRef(null);
    const printRef = useRef();
    const printRefRef = useRef();
    
    const [deleteModal, setDeleteModal] = useState({
      show: false,
      reference: null
    });

    const confirmDelete = async () => {
      try {
          const response = await axios.delete(
              `https://docuquest-swu.swucite.tech/api_drts/transactions.php/${deleteModal.reference}`
          );
          
          if (response.data.status === 1) {
              notify("success", `Transaction ${deleteModal.reference} deleted successfully`);
              
              setTransactions(prev => 
                  prev.filter(t => t.reference_number !== deleteModal.reference)
              );
              setFilteredTransactions(prev => 
                  prev.filter(t => t.reference_number !== deleteModal.reference)
              );
          } else {
              notify("error", `Failed to delete transaction: ${response.data.message}`);
          }
      } catch (error) {
          console.error("Error deleting transaction:", error);
          notify("error", "Error deleting transaction. Please try again.");
      }
      setDeleteModal({ show: false, reference: null });
    };

    const handleDeleteTransaction = async (referenceNumber) => {
        if (window.confirm(`Are you sure you want to delete transaction ${referenceNumber}? This action cannot be undone.`)) {
            try {
                const response = await axios.delete(
                    `https://docuquest-swu.swucite.tech/api_drts/transactions.php/${referenceNumber}`
                );
                
                if (response.data.status === 1) {
                    notify("success", `Transaction ${referenceNumber} deleted successfully`);
                    
                    // Update the transactions list by filtering out the deleted one
                    setTransactions(prev => 
                        prev.filter(t => t.reference_number !== referenceNumber)
                    );
                    setFilteredTransactions(prev => 
                        prev.filter(t => t.reference_number !== referenceNumber)
                    );
                } else {
                    notify("error", `Failed to delete transaction: ${response.data.message}`);
                }
            } catch (error) {
                console.error("Error deleting transaction:", error);
                notify("error", "Error deleting transaction. Please try again.");
            }
        }
    };    

    useEffect(() => {
        document.title = "Transactions";
    
        axios.post('https://docuquest-swu.swucite.tech/api_drts/checkSession.php', {}, { withCredentials: true })
        .then((res) => {
          // console.warn("is the session alive in singlerequest? ", res.data);
          if (res.data.status === 1) {
            setUserId(res.data.id);
            userIdRef.current = res.data.id;
            userFullnameRef.current = res.data.fullname;
          } 
        })
        .catch((err) => {
          //console.error("ERROR: Your session cannot be found!", err);
  
        });  

        axios.get('https://docuquest-swu.swucite.tech/api_drts/transactions.php')
        .then(async (response) => {            
            //console.warn("got data: ", response.data);
    
            // request.course
            const transactions = response.data
            
            .map(request => ({
                databaseId: request.id,
                reference: request.reference_number,
                receiptAttached: request.file_receipt ? "Yes" : "No receipt",
                docAttached: request.id_doc, 
                requestedAt: request.created_at,
                releasedAt:  request.released_at ? request.released_at : "-", 
                updatedAt: request.updated_at,
                requestor:  request.name_req,
                ownerLastName: request.lastname_owner,
                ownerFirstName: request.firstname_owner,
                ownerMiddleName: request.middlename_owner || "",
                ownerCourse: request.course,
                ownerYear: request.course_year,
                ownerLastYear: request.year_last,
                selectedDocs: request.selected_docs ? JSON.parse(request.selected_docs) : [],
                purpose: request.purpose_req,
                requestedType: request.doc_name,
                service_type: request.service_type,
                statusPayment: request.statusPayment,
                statusTransit: request.statusTransit,
                daysOverdue: request.overdue_days             
            }));
            
            // setTransactions(transactions);
            // setFilteredTransactions(transactions);
    
            // Update overdue days for each group
            const processedReferences = new Set();
            for (const group of transactions) {
                if (!processedReferences.has(group.reference)) {
                    await updateOverdueDays(group); 
                    processedReferences.add(group.reference); // Mark reference as processed
                }
            }
    
            //console.log("Updated transactions with overdue calculations.");
        }).catch((err)=> {
            //console.error("ERROR fetching transactions: ", err);
        });        
    }, []);

    const formatDateForFilename = () => {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.toLocaleString('en-US', { month: 'long' }); // Full month name
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}/${month}/${day}`;
    };


    const exportToExcel = () => {
        const truncateText = (text, maxLength = 32767) => {
            if (typeof text === 'string' && text.length > maxLength) {
              //console.warn(`Truncating text with ${text.length} characters to ${maxLength} characters.`);
              const truncatedText = text.slice(0, maxLength) + '...';
              return truncatedText;
            }
            return text;
          };
        
          const cleanData = (data) => {
            return data.map((row, index) => {
              const newRow = {};
              //console.log(`\nRow ${index + 1} - Original Data:`, row);
        
              for (const key in row) {
                // TODO exclude info for individual docs
                // Exclude unwanted fields
                if (['id',
                    'file_portrait', 
                    'id_doc',
                    'doc_name',
                    'doc_quantity',
                    'price',
                    'DOC_title',
                    'DOC_author', 
                    'DOC_category_id', 
                    'combinedData',
                    'id_employee'
                ].includes(key)) {
                  continue;
                }
        
                // Handle file_receipt
                if (key === 'file_receipt') {
                  newRow['Receipt'] = row[key] ? 'Receipt Attached' : 'No Receipt';
                  continue;
                }
        
                // Format selected_docs
                if (key === 'selected_docs') {
                  let docs = row[key];
                  if (typeof docs === 'string') {
                    try {
                      docs = JSON.parse(docs);
                    } catch (error) {
                      //console.error('Error parsing selected_docs:', error);
                      newRow['Documents Requested'] = 'Invalid documents';
                      continue;
                    }
                  }
                  newRow['Documents Requested'] = Array.isArray(docs) && docs.length > 0
                    ? docs.map(doc => doc.document).join(', ')
                    : 'No documents';
                  continue;
                }
        
                // Format purpose_req
                if (key === 'purpose_req') {
                  let purposes = row[key];
                  if (typeof purposes === 'string') {
                    try {
                      purposes = JSON.parse(purposes);
                    } catch (error) {
                      //console.error('Error parsing purpose_req:', error, 'Data:', row[key]);
                      newRow['Purpose'] = 'Invalid purpose';
                      continue;
                    }
                  }
                  newRow['Purpose'] = Array.isArray(purposes) && purposes.length > 0
                    ? purposes.join(', ')
                    : 'No purpose';
                  continue;
                }
        
                // Truncate other fields
                newRow[key] = truncateText(row[key]);
        
                // Example: Custom column name for other keys if needed
                  if (key === 'reference_number') {
                    newRow['Reference No.'] = row[key];
                    delete newRow[key]; // Remove original column to prevent duplicates
                  }
                  
                  if (key === 'service_type') {
                    newRow['Service'] = row[key];
                    delete newRow[key]; 
                  }
                  
                  if (key === 'delivery_region') {
                    newRow['Region'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'delivery_city') {
                    newRow['City'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'delivery_district') {
                    newRow['District'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'delivery_brgy') {
                    newRow['Barangay'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'delivery_street') {
                    newRow['Street'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'price_total') {
                    newRow['Total Price'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'name_req') {
                    newRow['Requestor'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'phone_req') {
                    newRow['Requestor Phone No.'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'email_req') {
                    newRow['Requestor Email'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'id_swu') {
                    newRow['Student ID'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'firstname_owner') {
                    newRow['Owner First Name'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'middlename_owner') {
                    newRow['Owner Middle Name'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'lastname_owner') {
                    newRow['Owner Last Name'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'phone_owner') {
                    newRow['Owner Phone No.'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'course') {
                    newRow['Course'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'course_year') {
                    newRow['S.Y First Enrolled'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'year_last') {
                    newRow['S.Y Last Enrolled'] = row[key];
                    delete newRow[key]; 
                  }
                  
                  if (key === 'desc_req') {
                    newRow['Request Description'] = row[key];
                    delete newRow[key]; 
                  }

                  // if (key === 'id_employee') {
                  //   newRow['User ID'] = row[key];
                  //   delete newRow[key]; 
                  // }

                  if (key === 'USER_firstname') {
                    newRow['Staff First Name'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'USER_middlename') {
                    newRow['Staff Middle Name'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'USER_lastname') {
                    newRow['Staff Last Name'] = row[key];
                    delete newRow[key]; 
                  }

                  if (key === 'updated_overdue') {
                    newRow['Last Overdue Days No. Update'] = row[key];
                    delete newRow[key];
                  }

                  if (key === 'released_at') {
                    newRow['Release Date'] = row[key];
                    delete newRow[key];
                  }                  

                  if (key === 'created_at') {
                    newRow['Request Date'] = row[key];
                    delete newRow[key];
                  }
                  
                  if (key === 'updated_at') {
                    newRow['Request Updated'] = row[key];
                    delete newRow[key];
                  }

                  if (key === 'reason_reject') {
                    newRow['Rejection Reason'] = row[key];
                    delete newRow[key];
                  }

                  if (key === 'remarks') {
                    newRow['Rejection Remarks'] = row[key];
                    delete newRow[key];
                  }

                  if (key === 'payment_channel') {
                    newRow['Payment Method'] = row[key];
                    delete newRow[key];
                  }
                  
                  if (key === 'statusPayment') {
                    newRow['Payment Status'] = row[key];
                    delete newRow[key];
                  }
                  
                  if (key === 'statusTransit') {
                    newRow['Status'] = row[key];
                    delete newRow[key];
                  }
                  
                  if (key === 'overdue_days') {
                    newRow['Days Beyond Target Completion'] = row[key];
                    delete newRow[key];
                  }
              }
              //console.log(`Row ${index + 1} - Cleaned Data:`, newRow);
              return newRow;
            });
          };
        
          try {
            if (!filteredTransactions || filteredTransactions.length === 0) {
              //console.error('No data available to export.');
              return;
            }
        
            //console.log('Filtered Transactions:', filteredTransactions);
        
            const sanitizedData = cleanData(filteredTransactions);
            //console.log('Sanitized Data:', sanitizedData);
        
            // Ensure correct columns by creating headers from cleaned data
            const keys = Array.from(
              new Set(sanitizedData.flatMap((row) => Object.keys(row)))
            );
        
            const worksheet = XLSX.utils.json_to_sheet(sanitizedData, { header: keys });
            const workbook = XLSX.utils.book_new();
        
            const lastRow = sanitizedData.length + 2;
            const formattedDate = formatDateForFilename();
            const reportedBy = userFullnameRef.current.toUpperCase();

            XLSX.utils.book_append_sheet(workbook, worksheet, `TS_${reportedBy}`); // first sheet name
        
            XLSX.utils.sheet_add_aoa(worksheet, [
              ['Reported by:', reportedBy],
              ['Export Date:', { v: new Date(), t: 'd', z: 'yyyy/mm/dd' }],
            ], { origin: `A${lastRow}` });

            const maxColumnWidths = keys.map((key) => ({
              wch: Math.max(15, key.length + 5),
            }));
            worksheet['!cols'] = maxColumnWidths;

            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            
            saveAs(blob, `Transactions ${reportedBy} ${formattedDate}.xlsx`); // file name
            //console.log('Export successful!');
          } catch (error) {
            //console.error('Error exporting data:', error);
          }
    };
    
    const handlePrint = useReactToPrint({
        // tableRef,
        contentRef: printRefRef,
        documentTitle: `Transactions`,
        // onBeforePrint: () => setIsPrinting(true),
        // onAfterPrint: () => setIsPrinting(false),
    });

    

    useEffect(() => {
      let updatedTransactions = transactions_data;

      // Apply Dropdown Filter
      if (selectedVerticalTab !== "All") {
        updatedTransactions = updatedTransactions.filter(transaction =>
          transaction.statusTransit === selectedVerticalTab ||
          transaction.statusPayment === selectedVerticalTab ||
          transaction.service_type === selectedVerticalTab
        );
      }
    
      // Apply Search Filter
      if (searchValue.trim() !== "") {
        updatedTransactions = updatedTransactions.filter(transaction =>
          Object.values(transaction).some(val =>
            String(val).toLowerCase().includes(searchValue.toLowerCase())
          )
        );
      }
    
      // Apply Date Range Filters
      Object.keys(dateFilters).forEach((key) => {
        const { enabled, start, end } = dateFilters[key];
        
        if (enabled && start && end) {
          updatedTransactions = updatedTransactions.filter((transaction) => {
            const transactionDate = transaction[`${key}_at`]; // Ensure this matches your actual data keys
      
            // Use the isWithinRange function for cleaner comparison
            return isWithinRange(transactionDate, start, end);
          });
        }
      });
    
      setFilteredTransactions(updatedTransactions);
      setPageNow(1);
    }, [transactions_data, selectedVerticalTab, searchValue, dateFilters]);

    useEffect(() => {
        if (!userIdRef.current) return;
    
        axios.get(`https://docuquest-swu.swucite.tech/api_drts/users.php/${userIdRef.current}`)
            .then(res => {
                //console.log("Fetched user info:", res.data);
                //console.log("Fetched user courses:", res.data.user_courses); // Debugging
                let userCourses;
    
                // Ensure `user_courses` is a string before calling `.split()`
                if (Array.isArray(res.data.user_courses)) {
                    userCourses = res.data.user_courses;
                } else if (typeof res.data.user_courses === "string") {
                    userCourses = res.data.user_courses.split(',');
                } else {
                    //console.warn("Unexpected type for user_courses:", res.data.user_courses);
                    userCourses = []; // Default to empty array
                }

                // Prevent unnecessary updates
                setUserCourses(prevCourses => {
                    if (JSON.stringify(prevCourses) === JSON.stringify(userCourses)) {
                        return prevCourses; // No state change needed
                    }
                    return userCourses;
                });
            })
            .catch(err => {
              // console.error("Error fetching user courses:", err)
            });
    }, [userId]); // Runs only when `userId` changes
    

    useEffect(() => {
        if (!userCourses || userCourses.length === 0) {
            //console.warn("⚠️ No courses assigned to this user! Transactions will be hidden.");
            setTransactions(prev => (prev.length === 0 ? prev : []));
            setFilteredTransactions(prev => (prev.length === 0 ? prev : []));
            return;
        }
    
        Promise.all([
            axios.get("https://docuquest-swu.swucite.tech/api_drts/courses.php"),
            axios.get("https://docuquest-swu.swucite.tech/api_drts/transactions.php")
        ])
        .then(([res_courses, res_transactions]) => {
            const coursesMap = {};
            res_courses.data.courses.forEach(course => {
                coursesMap[course.id] = course.course_name.toUpperCase();
            });
    
            //console.log("Courses Map:", coursesMap);
    
            // **Filter transactions based on userCourses**
            //console.warn("userCourses some filter: ", userCourses);
            const filteredTransactions = userCourses?.length
            ? res_transactions.data.filter(transaction => 
                userCourses.some(courseName => 
                    transaction.course && courseName.toUpperCase() === transaction.course.toUpperCase()
                )
            )
            : res_transactions.data;
          
        
            //console.warn("res_transactions.data: ", res_transactions.data);
            //console.log("Filtered Transactions Before Grouping:", filteredTransactions);
    
            // **Grouping Transactions by Reference Number**
            const groupedTransactions = filteredTransactions.reduce((acc, transaction) => {
                const refNumber = transaction.reference_number;
    
                // Initialize group if it doesn't exist
                if (!acc[refNumber]) {
                    acc[refNumber] = {
                        ...transaction, // Base object from first transaction
                        combinedData: [] // Array to store grouped transactions
                    };
                }
    
                // Add transaction to its respective group
                acc[refNumber].combinedData.push(transaction);
    
                return acc;
            }, {});
    
            // Convert grouped transactions from an object to an array
            const groupedArray = Object.values(groupedTransactions);
    
            //console.log("Grouped Transactions:", groupedArray);
            //console.warn("paginatedTransactions: ", paginatedTransactions);

            // **Set the transactions state only if they have changed**
            // setTransactions(prevTransactions => {
            //     if (JSON.stringify(prevTransactions) === JSON.stringify(groupedArray)) {
            //         return prevTransactions;
            //     }
            //     return groupedArray;
            // });
    
            // setFilteredTransactions(prevFiltered => {
            //     if (JSON.stringify(prevFiltered) === JSON.stringify(groupedArray)) {
            //         return prevFiltered;
            //     }
            //     return groupedArray;
            // });
            
            setTransactions(groupedArray);
            setFilteredTransactions(groupedArray);

            setVerticalTab("All");
            filterTransactions("All", searchValue, selectedDocumentCategory);
        })
        .catch(err => {
          // console.error("Error fetching courses or transactions:", err)
        });
    
    }, [userCourses]);
    
    useEffect(() => {
        let updatedTransactions = filteredTransactions;

        if (selectedVerticalTab !== "All") {
            updatedTransactions = updatedTransactions.filter(transaction =>
                transaction.statusTransit === selectedVerticalTab ||
                transaction.statusPayment === selectedVerticalTab ||
                transaction.service_type === selectedVerticalTab
            );
        }
    
        if (searchValue.trim() !== "") {
            updatedTransactions = updatedTransactions.filter(transaction =>
                Object.values(transaction).some(val =>
                    String(val).toLowerCase().includes(searchValue.toLowerCase())
                )
            );
        }

        setFilteredTransactions(prev => 
            JSON.stringify(prev) === JSON.stringify(updatedTransactions) ? prev : updatedTransactions
        );
    }, [filteredTransactions, selectedVerticalTab, searchValue]);


    const [documentCategories, setDocumentCategories] = useState([]);
    const [selectedDocumentCategory, setSelectedDocumentCategory] = useState("All");

    // Fetch document categories for filter
    useEffect(() => {
      const fetchDocumentCategories = async () => {
          try {
              const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/filterTypeDocs.php');
              setDocumentCategories(response.data.records || []);
          } catch (error) {
              //console.error("Error fetching document categories:", error);
              notify("error", "Failed to load document categories");
          }
      };
      
      fetchDocumentCategories();
    }, []);

    const filterTransactions = (filter, search, docCategory) => {
        let updatedTransactions = transactions_data;
        
        // Apply status/payment/service filter
        if (filter !== "All") {
            updatedTransactions = updatedTransactions.filter(request => 
                request.statusTransit === filter ||
                request.statusPayment === filter || 
                request.service_type === filter
            );
        }
        
        // Apply search filter
        if (search.trim() !== "") {
            updatedTransactions = updatedTransactions.filter(request =>
                Object.values(request).some(val =>
                    String(val).toLowerCase().includes(search.toLowerCase())
                )
            );
        }

        // Apply document category filter
        if (docCategory !== "All") {
          updatedTransactions = updatedTransactions.filter(request => {
              try {
                  const docs = typeof request.selected_docs === 'string' 
                      ? JSON.parse(request.selected_docs) 
                      : request.selected_docs || [];
                  
                  return Array.isArray(docs) && 
                      docs.some(doc => doc.document === docCategory);
              } catch (error) {
                  //console.error("Error parsing selected_docs:", error);
                  return false;
              }
          });
        }

        // Apply Date Filters
        Object.keys(dateFilters).forEach((key) => {
          const { enabled, start, end } = dateFilters[key];
          
          if (enabled && start && end) {
            updatedTransactions = updatedTransactions.filter((transaction) => {
              const transactionDate = transaction[`${key}_at`]; // Ensure this matches your actual data keys
        
              // Use the isWithinRange function for cleaner comparison
              return isWithinRange(transactionDate, start, end);
            });
          }
        });
                
        setFilteredTransactions(updatedTransactions);
        setPageNow(1);
    };

    const handleDocumentCategoryChange = (e) => {
      const category = e.target.value;
      setSelectedDocumentCategory(category);
      filterTransactions(selectedVerticalTab, searchValue, category);
    };

    const handleDropdownFilterChange = (e) => {
        const filter = e.target.value;
        setVerticalTab(filter);
        filterTransactions(filter, searchValue, selectedDocumentCategory);
    };

    const handleSearchChange = (e) => {
        const search = e.target.value;
        setSearchValue(search);
        filterTransactions(selectedVerticalTab, search, selectedDocumentCategory);
    };

    const handleRadioChange = (name) => {
        setVerticalTab(name);
        filterTransactions(name, searchValue, selectedDocumentCategory);
        // console.warn("transactions_data", transactions_data);
        
        const filteredByRadiobutton = transactions_data.filter((request) => {
            switch (name) {
              case "All":
                return true;
              case "Paid":
                return request.statusPayment === "Paid";
              case "Not Paid":
                return request.statusPayment === "Not Paid";
              case "Pickup":
                return request.service_type === "Pickup";
              case "Delivery":
                return request.service_type === "Delivery";
              case "Request Placed":
                return request.statusTransit === "Request Placed";
              case "In Review":
                return request.statusTransit === "In Review";
              case "Accepted":
                return request.statusTransit === "Accepted";
              case "Rejected":
                return request.statusTransit === "Rejected";
              case "Processing":
                return request.statusTransit === "Processing";
              case "Completed":
                return request.statusTransit === "Completed";  
              case "For Releasing":
                return request.statusTransit === "For Releasing";
              case "Out for Delivery":
                return request.statusTransit === "Out for Delivery";  
              case "Ready to Pick Up":
                return request.statusTransit === "Ready to Pick Up";                
              case "Received":
                return request.statusTransit === "Received";
              case "Claimed":
                return request.statusTransit === "Claimed"; 
              case "Delivered":
                return request.statusTransit === "Delivered";               
              case "In Transit":
                return request.statusTransit === "In Transit";
              case "Overdue":
                return request.daysOverdue > 0;  
              default:
                return true;
            }
        });

        const filteredBySearch = filteredByRadiobutton.filter((request) =>
            Object.values(request).some((val) =>
            String(val).toLowerCase().includes(searchValue.toLowerCase())    
        ));
        
        setFilteredTransactions(filteredBySearch);
        setPageNow(1);
    }

    const formatToSQLDateTime = (isoDateTime) => {
        const date = new Date(isoDateTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = "00"; // Manually set seconds to match SQL format
    
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const updateOverdueDays = async (group) => {
        if (!group.releasedAt || ["Received", "Claimed", "Delivered"].includes(group.statusTransit)) {
            return; // Skip transactions that are already received, claimed, or delivered
        }
    
        const releasedAtDate = new Date(group.releasedAt);
        const currentDate = new Date();
    
        // Calculate days overdue
        const timeDiff = currentDate - releasedAtDate;
        const daysOverdue = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    
        if (daysOverdue > 0) {
            try {
                // Fetch existing overdue data
                const overdueResponse = await axios.get(
                    `https://docuquest-swu.swucite.tech/api_drts/transactionsOverdue.php/${group.reference}`,
                    { params: { lastname_owner: group.ownerLastName } }
                );
    
                let lastUpdatedOverdue = overdueResponse.data?.updated_overdue 
                    ? new Date(overdueResponse.data.updated_overdue) 
                    : null;
                let currentOverdueDays = parseInt(overdueResponse.data?.overdue_days, 10) || 0;
    
                const today = formatToSQLDateTime(new Date().toISOString()).split(" ")[0];
    
                // Fetch existing notifications for this reference
                const notifResponse = await axios.get(`https://docuquest-swu.swucite.tech/api_drts/userNotifications.php/${userIdRef.current}`);
                const existingNotifs = Array.isArray(notifResponse.data) ? notifResponse.data : [];
    
                // Check if a notification for this overdue transaction was already sent today
                const hasNotificationToday = existingNotifs.some(
                    (notif) => 
                        notif.message.includes(`${group.reference} is ${daysOverdue} days overdue`) &&
                        notif.created_at.startsWith(today)
                );
    
                // Update overdue days **only if it hasn't been updated today**
                if ((!lastUpdatedOverdue || lastUpdatedOverdue.toDateString() < currentDate.toDateString()) &&
                    daysOverdue > currentOverdueDays) {
                    
                    await axios.patch(
                        `https://docuquest-swu.swucite.tech/api_drts/transactionsOverdue.php/${group.reference}`,
                        {
                            owner_lastname: group.ownerLastName,
                            overdue_days: daysOverdue,
                            staff: userIdRef.current,
                            requestor_email: group.requestor,
                            service: group.requestedType,
                            selected_docs: group.selectedDocs,
                            last_overdue_update: formatToSQLDateTime(new Date().toISOString()),
                        }
                    );
    
                    //console.log(`Updated overdue days for ${group.reference}: ${daysOverdue} days`);
    
                    // **Update State After Backend Update**
                    setTransactions(prevTransactions => 
                        prevTransactions.map(item => 
                            item.reference === group.reference
                                ? { ...item, daysOverdue }
                                : item
                        )
                    );
    
                    setFilteredTransactions(prevFiltered => 
                        prevFiltered.map(item => 
                            item.reference === group.reference
                                ? { ...item, daysOverdue }
                                : item
                        )
                    );
    
                    // Send a notification **only if one hasn't been sent today**
                    if (!hasNotificationToday) {
                        await axios.post(`https://docuquest-swu.swucite.tech/api_drts/userNotifications.php`, {
                            user_id: userIdRef.current,
                            type: "warning",
                            message: `${group.reference} is ${daysOverdue} days overdue!`,
                        });
    
                        //console.log(`Sent notification: ${group.reference} is ${daysOverdue} days overdue!`);
                    } else {
                        //console.log(`Notification already sent today for ${group.reference}. Skipping.`);
                    }
                }
            } catch (err) {
                //console.error(`Error updating overdue days for ${group.reference}:`, err);
            }
        }
    };
    
    // Group transactions by reference
    const groupTransactionsByReference = (transactions) => {
        const grouped = {};
        transactions.forEach((doc) => {
            if (!doc.reference) return; // Skip invalid transactions
            if (!grouped[doc.reference]) {
                grouped[doc.reference] = {
                    ...doc,
                    combinedData: [],
                };
            }
            grouped[doc.reference].combinedData.push(doc);
        });
        return Object.values(grouped);
    };
    

    // Apply grouping to filteredTransactions
    const groupedTransactions = filteredTransactions.length > 0 
    ? groupTransactionsByReference(filteredTransactions) 
    : [];

    // pagination
    const rowsNow = 15; // 15 rows per page
    const [pageNow, setPageNow] = useState(1);
    
    useEffect(() => {
        setPageNow(1); // Reset to first page when transactions update
        
        // console.warn("new filteredTransactions: ", filteredTransactions);
        
        // console.warn("new reference_number: ", filteredTransactions.reference_number);
        // console.warn("new lastname_owner: ", filteredTransactions.lastname_owner);
        
        // console.warn("pageNumbers: ", pageNumbers);
    }, [filteredTransactions, selectedVerticalTab, searchValue]);
    
    var indxLast = pageNow * rowsNow;
    var indxFirst = indxLast - rowsNow;
    
    const currentRows = filteredTransactions.slice(indxFirst, indxLast);
    var pageTotal = Math.max(1, Math.ceil(filteredTransactions.length / rowsNow));
    var pageNumbers = [...Array(pageTotal + 1).keys()].slice(1);
    //console.warn("Total pages: ", pageTotal);
    
    const pagePrev = () => {
        if (pageNow > 1) {
            setPageNow(pageNow - 1)
        }
    }

    const pageNext = () => {
        if (pageNow < pageTotal) {
            setPageNow(pageNow + 1)
        }
    }

    const changePage = (id) => {
        setPageNow(id)
    }

    const handleNavigation = (path) => {
        navigate(path);
    };
    


    {/* TODO archive function
    - button documents archive 
    - button transactions archive
    */}

    return (
        <div className="printable-container">
            <header className="header">
              <h1>Document Requests</h1>
            </header>

            <section className='dash_overview'>
              <article className='dash-group'>

                <section className='dash-row'>
                    <Button variant='secondary' size='sm' onClick={exportToExcel} className="export-button">
                      Export to Excel
                    </Button>
                    
                    <Button variant='secondary' size='sm' onClick={handlePrint} className="print-button">
                      Print Table
                    </Button>
                </section>

                <section className='dash-row'>
                  <div className='dash-unit'>
                    <input
                    type="text"
                    placeholder="Search"
                    value={searchValue}
                    onChange={handleSearchChange}
                    className="search-input group"
                    />
                  </div>
                </section>
                  
                <section className='dash-row'>
                  {/* Transit and Payment Status Filter */}
                  <select
                  className='dropdown-filter'
                  title='Filter transactions by transit status or payment status'
                  onChange={handleDropdownFilterChange}
                  value={selectedVerticalTab}
                  >
                    {totalVerticalbar.map((item, index) => (
                        <option key={index} value={item.name}>
                          {item.name}
                        </option>
                    ))}
                  </select>

                  {/* Document Category Filter */}
                  <select
                      className='dropdown-filter'
                      title='Filter by document type'
                      onChange={handleDocumentCategoryChange}
                      value={selectedDocumentCategory}
                  >
                      <option value="All">All Document Types</option>
                      {documentCategories.map((category) => (
                          <option key={category.id} value={category.name}>
                              {category.name}
                          </option>
                      ))}
                  </select>
                </section>

                <section className='dash-row'>
                  {/* range dates */}
                  {['released', 'created', 'updated'].map((type) => (
                    <div key={type}>
                      <label>
                        <input
                          type="checkbox"
                          checked={dateFilters[type].enabled}
                          onChange={() => handleCheckboxChange(type)}
                        />
                        {type.charAt(0).toUpperCase() + type.slice(1)} At
                      </label>

                      <article className='dash-group range'>
                        <input
                          type="date"
                          value={dateFilters[type].start}
                          onChange={(e) => handleDateChange(type, 'start', e.target.value)}
                          disabled={!dateFilters[type].enabled}
                        />
                        <input
                          type="date"
                          value={dateFilters[type].end}
                          onChange={(e) => handleDateChange(type, 'end', e.target.value)}
                          disabled={!dateFilters[type].enabled}
                        />
                      </article>
                    </div>
                  ))} 
                </section>

              </article>

                {/* <section className='verticalbar'>
                    <Form>
                    {totalVerticalbar.map((item, index) => (
                        <div
                          key={`filter-${index}`}
                          title={item.name}
                          className={`item_verticalbar ${selectedVerticalTab === item.name? "active" : ""}`}
                          onClick={() => handleRadioChange(item.name)}  
                        >
                        <Form.Check
                          label={item.name}
                          name="filterOptions"
                          type='radio'
                          checked={selectedVerticalTab === item.name}
                          style={{ display : "none" }}
                          onClick={() => handleRadioChange(item.name)}   
                        />   
                            {item.icon}
                            <div>{item.name}</div>
                        </div>
                    ))}
                    </Form>
                </section> */}
                
                {/* TODO filter */}
             
            {/* <article className='stat_box standalone'>
                    <h6 className='title'>Total</h6>
                    <p className='title body'>{dataCounts.total}</p>
                </article>
                <article className='stat_box standalone'>
                    <h6 className='title'>Fully&nbsp;Paid</h6>
                    <p className='title body'>{dataCounts.fullyPaid}</p>
                </article>
                <article className='stat_box standalone'>
                    <h6 className='title'>Pending&nbsp;Balance</h6>
                    <p className='title body'>{dataCounts.pendingBalance}</p>
                </article>
                <article className='stat_box standalone'>
                    <h6 className='title'>Archived</h6>
                    <p className='title body'>{dataCounts.archived}</p>
                </article> */}
            </section>
            <div className="print-header" ref={printRefRef}>
              <div className="print-header" >
                {/* Center - Title */}
                <h2 className="print-title">DOCUMENT REQUESTS TRANSACTIONS</h2>

                {/* Left side - Logo & Address */}
                <div className="print-header-left">
                  <div className="print-logo-container">
                    <img
                      src={logoTransactions}
                      alt="Southwestern University Logo"
                      className="print-logo"
                    />
                  </div>

                  <div className="print-address">
                    Southwestern University, Urgello St., Cebu City, Philippines
                  </div>
                </div>

                {/* Right side - Generated Date */}
                <div className="print-date">
                  Generated on:{" "}
                  {new Date().toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </div>
              </div>
                     
             

          {/* ref={tableRef} */}
            <table className="documents-table" ref={tableRef}>
                <thead>
                {filteredTransactions.length > 0 && (
                    <tr>
                        <th>Reference&nbsp;No.</th>
                        <th>Release&#32;Date</th>
                        <th>Request&#32;Date</th>
                        <th>Updated</th>
                        <th>Owner&nbsp;Name</th>
                        <th>Course</th>
                        <th>Receipt</th>
                        <th>Documents&nbsp;Requested</th>
                        <th>Purpose</th>
                        <th>Payment&nbsp;Status</th>
                        <th>Status</th>
                        <th>Days&nbsp;beyond&#32;target&nbsp;completion</th>
                        <th>Action</th>
                    </tr>
                )}
                </thead>
                <tbody>
                {
                    currentRows.length > 0 ? ( 
                        currentRows.map((transaction, index) => (
                        <tr key={transaction.id} onClick={()=>{navigate(`/respond/${transaction.reference_number}`, {state: {lastname: transaction.lastname_owner}} )}}> 
                            <td>{transaction.reference_number}</td>
                            <td>{!transaction.released_at || transaction.released_at === "null" ? "-" : formatDate(transaction.released_at)}</td>
                            <td>{formatDate(transaction.created_at)}</td>
                            <td>{formatDate(transaction.updated_at)}</td>
                            <td>
                                {`${transaction.lastname_owner}, ${transaction.firstname_owner} ${transaction.middlename_owner ? transaction.middlename_owner[0] + "." : ""}`}
                            </td>
                            <td>{transaction.course}</td>
                            <td>{transaction.file_receipt ? "Receipt Attached"
                                : "No Receipt"}
                            </td>
                            <td>
                            {(() => {
                                let docs = transaction.selected_docs;

                                // Check if it's a string and try to parse it
                                if (typeof docs === 'string') {
                                try {
                                    docs = JSON.parse(docs);
                                } catch (error) {
                                    //console.error('Error parsing selected_docs:', error);
                                    return 'Invalid documents';
                                }
                                }

                                // Render documents if valid
                                return Array.isArray(docs) && docs.length > 0
                                ? docs.map((doc, idx) => (
                                    <span key={idx}>
                                        {doc.document}
                                        {idx < docs.length - 1 ? ', ' : ''}
                                    </span>
                                    ))
                                : 'No documents';
                            })()}
                            </td>
                            <td>
                              {(() => {
                                let purposes = transaction.purpose_req;

                                // Check if it's a string and try to parse it
                                if (typeof purposes === 'string') {
                                  try {
                                    purposes = JSON.parse(purposes);
                                  } catch (error) {
                                    //console.error('Error parsing purpose_req:', error);
                                    return 'Invalid purposes';
                                  }
                                }

                                // Render purposes if valid
                                return Array.isArray(purposes) && purposes.length > 0
                                  ? purposes.map((purpose, idx) => (
                                      <span key={idx}>
                                        {purpose}
                                        {idx < purposes.length - 1 ? ', ' : ''}
                                      </span>
                                    ))
                                  : 'No purposes';
                              })()}
                            </td>
                            <td className={getStatusPayment(transaction.statusPayment)}>{transaction.statusPayment}</td>
                            <td className={"status " + buildStatusClass(transaction.statusTransit)}>{transaction.statusTransit}</td>
                            <td className="">
                                {transaction.overdue_days > 0 ? transaction.overdue_days : "Not overdue"}
                            </td>
                            <td>
                                <button 
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent row click navigation
                                        handleDeleteTransaction(transaction.reference_number)
                                    }}
                                    className="delete-button"
                                    title="Delete this transaction"
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={15}>
                                No results for "{searchValue}" in transactions {selectedVerticalTab}
                            </td>
                        </tr>
                    )

                }
                </tbody>
            </table>

            {deleteModal.show && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>Confirm Deletion</h3>
                        <p>Are you sure you want to delete transaction {deleteModal.reference}? This action cannot be undone.</p>
                        <div className="modal-buttons">
                            <button onClick={() => setDeleteModal({ show: false, reference: null })}>
                                Cancel
                            </button>
                            <button onClick={confirmDelete} className="delete-button">
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* style={{ display: isPrinting ? "block" : "none" }} */}
            <div className="print-footer">
              Page {pageNow} of {pageTotal}
            </div>

            </div> 
            {
                filteredTransactions.length > 0 && (
                <div className="pagination">
                    <button onClick={() => changePage(1)} disabled={pageNow === 1}>
                        &lt;&lt;
                    </button>
                    <button onClick={pagePrev} disabled={pageNow === 1}>
                        &lt; Previous
                    </button>
                    {pageNumbers.map((number) => (
                        <button
                            key={number}
                            onClick={() => changePage(number)}
                            className={pageNow === number ? "active" : ""}
                        >
                            {number}
                        </button>
                    ))}
                    <button onClick={pageNext} disabled={pageNow === pageTotal}>
                        Next &gt;
                    </button>
                    <button onClick={() => changePage(pageTotal)} disabled={pageNow === pageTotal}>
                        &gt;&gt;
                    </button>
                </div>
                )
            }
        <ToastContainer newestOnTop/>
        </div>
    )
}